<template>
  <div class="site-page row">
    <div class="col-md-12 page-title">
      <h1>Opérations Mobile Money</h1>
      <p class="text-muted">Opérations et services liés à Mobile Money</p>
    </div>
    <div class="col-md-9">
      <div class="row">
        <ServiceCard
          :key="index"
          v-for="(item, index) in items"
          :description="item.description"
          :title="item.title"
          :link_type="item.link_type"
          :extern_link="item.extern_link"
          :url="item.url"
          :modal_id="item.action"
        />
        <div
          v-for="(item, index) in items"
          :key="'selector' + index"
          :class="item.tour_class"
        />
      </div>
    </div>
    <div id="home_side_bar" class="col-md-3">
      <InfoSimWidget />
      <OtherSimWidget />
    </div>
  </div>
</template>

<script>
import ServiceCard from "@/components/utils/ServiceCard";
import InfoSimWidget from "@/components/home/InfoSimWidget";
import OtherSimWidget from "@/components/home/OtherSimWidget";
export default {
  components: { ServiceCard, InfoSimWidget, OtherSimWidget },
  name: "MobileMoney",
  data: function () {
    return {
      items: this.utils_get_config_item("mobile_money"),
    };
  },
  mounted: async function () {},
  methods: {},
};
</script>
<style scoped lang="css">
</style>
